/**
 * BESTIX v5.0 — Heat Indicator
 * Visual demand indicator (1-5 dots)
 */

import { cn } from '@/lib/utils';

interface HeatIndicatorProps {
  level: 1 | 2 | 3 | 4 | 5;
  size?: 'sm' | 'md';
}

export function HeatIndicator({ level, size = 'md' }: HeatIndicatorProps) {
  const dots = [1, 2, 3, 4, 5];
  const isHot = level >= 4;

  return (
    <div className="flex items-center gap-1">
      {dots.map((dot) => (
        <span
          key={dot}
          className={cn(
            'rounded-full',
            size === 'sm' ? 'w-1.5 h-1.5' : 'w-2 h-2',
            dot <= level 
              ? (isHot ? 'bg-[var(--color-hot)]' : 'bg-[var(--color-gold)]') 
              : 'bg-gray-200'
          )}
        />
      ))}
    </div>
  );
}

export default HeatIndicator;
